import React from "react";
import { Badge } from "reactstrap";

const PLATFORM_CLASS: Record<string, string> = {
  shopify: "badge-platform-shopify",
  woocommerce: "badge-platform-woocommerce",
  square: "badge-platform-square",
  lightspeed: "badge-platform-lightspeed",
};

const PlatformBadge: React.FC<{ platform?: string | null }> = ({ platform }) => {
  const key = String(platform || "").trim().toLowerCase();
  const colorClass = PLATFORM_CLASS[key] || "badge-platform-default";

  return (
    <Badge pill className={`text-capitalize border-0 ${colorClass}`}>
      {platform || "Unknown"}
    </Badge>
  );
};

export default PlatformBadge;
